import { normalizeTcgSetCode } from '@/services';
import type { Printing, TcgCardSuggestion } from '@/types';

const MAX_ASSOCIATED_SET_CODES = 80;

export function getSuggestionSetCodes(suggestions: TcgCardSuggestion[]): string[] {
  const codes = new Set<string>();

  for (const suggestion of suggestions) {
    for (const variant of suggestion.variants ?? []) {
      if (!variant.setCode) continue;
      codes.add(normalizeTcgSetCode(variant.setCode));
      if (codes.size >= MAX_ASSOCIATED_SET_CODES) {
        return Array.from(codes);
      }
    }
  }

  return Array.from(codes);
}

export function mergePrintingsByIdentity(...groups: Printing[][]): Printing[] {
  const seen = new Set<string>();
  const merged: Printing[] = [];

  for (const printing of groups.flat()) {
    const key = [
      printing.card.id,
      printing.setCode ?? '',
      printing.setRarityCode ?? printing.setRarity ?? '',
      printing.setEdition ?? '',
      printing.id,
    ].join('|');

    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(printing);
  }

  return merged;
}
